import * as React from 'react';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';
import type {GetInvoices_invoices as Invoice} from 'nutshell-graphql-types';

import {getQuoteTimes} from '../../../../../../ui/lead/sales-documents/shared';

import {StackLegacy} from '../../layout/stack/stack-legacy';

import {getInvoiceActionMenuOptions} from './helpers';
import {SalesDocumentRow} from './sales-document-row';

type Props = {
    invoices: Invoice[];
    handleDownloadInvoice: (arg1: string) => void;
    handleUpdateInvoiceStatus: (id: string, status: QuoteDisplayStatus) => void;
    handleDuplicateInvoice: (id: string) => void;
    handleSendInvoiceViaEmail: () => void;
};

export function InvoicesSection(props: Props) {
    return (
        <StackLegacy spacing={16}>
            {props.invoices.map((invoice) => (
                <SalesDocumentRow
                    key={invoice.id}
                    type='Invoice'
                    salesDocumentTimes={getQuoteTimes(invoice)}
                    actionMenuOptions={getInvoiceActionMenuOptions(
                        invoice.id,
                        invoice.shareableViewInBrowserLink,
                        invoice.slug,
                        invoice.displayStatus,
                        props.handleDownloadInvoice,
                        props.handleDuplicateInvoice,
                        props.handleUpdateInvoiceStatus,
                        props.handleSendInvoiceViaEmail
                    )}
                    modalUrl={invoice.modalUrl}
                    displayNumber={invoice.displayNumber}
                    price={invoice.total.formattedWithCents}
                    status={invoice.displayStatus}
                    invoiceOverdueDuration={invoice.overdueDuration}
                />
            ))}
        </StackLegacy>
    );
}
